import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
// A single shout. Registered with app.store as the 'shouts' type so reads,
// creates and deletes go through the store (cached, reactive, user sideloaded)
// instead of hand-built requests.
export default class Shout extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "canDelete", Model.attribute('canDelete'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('linkrobins-shoutbox', 'forum/models/Shout', Shout);